class CorrectAnswerFinder {
    isCorrect(selectedAnswer, correctAnswer) {
        return selectedAnswer === correctAnswer;
    }
}

export default CorrectAnswerFinder;